import hasAuthCookie from './has-auth-cookie';

const requestContextEventHandler = ({ ctx }) => {
  if (hasAuthCookie(ctx)) {
    ctx.disableSsr = true;
  }
};

export default requestContextEventHandler;
